import { StreamingPlayerImage, StreamingPlayerTypography } from '@heardis/stream-contracts';
import { useAuthContext } from '../../../contexts/AuthContext';
import HeardisLogo from '../../../elements/HeardisLogo';
import { BackgroundImage } from '../../Image';
import classes from './Footer.module.css';

type FooterProps = {
  typography: StreamingPlayerTypography;
  backgroundColor: string;
  backgroundImage: StreamingPlayerImage;
  showCookieBanner?: () => void;
  analyticsEnabled?: boolean;
};

function Footer({ typography, backgroundColor, backgroundImage, showCookieBanner, analyticsEnabled = false }: FooterProps): JSX.Element {
  const { user, signOut } = useAuthContext();
  const { fontFamily, fontSize, fontWeight, color } = typography;

  return (
    <footer className={classes.footer} style={{ backgroundColor, fontFamily, fontSize, fontWeight, color }}>
      <HeardisLogo style={{ fill: 'currentcolor' }} />
      <p>
        {`Brought to you by HearDis! © ${new Date().getFullYear()} | `}
        <a href="https://www.heardis.com/en/legal-notes" target="_blank" rel="noopener noreferrer">Legal Notes</a>
        {' / '}
        {analyticsEnabled ?
          <button type="button" onClick={showCookieBanner}>Privacy</button> :
          <a href="https://www.heardis.com/en/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>}
        {user && (
          <>
            {' / '}
            <button type="button" onClick={() => signOut()}>Logout</button>
          </>
        )}
      </p>
      {backgroundImage.url && (
        <BackgroundImage
          url={backgroundImage.url}
          alt={backgroundImage.alt}
          blur={backgroundImage.blur}
          position={backgroundImage.position}
          fit={backgroundImage.fit}
          zIndex={-5}
        />
      )}
    </footer>
  );
}

export default Footer;
